export default "__VITE_ASSET__CgU841fI__"